import { useFormApi } from '@data-driven-forms/react-form-renderer';
import { useState } from 'react';

import Button from '~/common/components/Button';
import Flex from '~/common/components/Flex';
import ChakraModal from '~/common/components/Modals/Modal';
import ModalBody from '~/common/components/Modals/ModalBody';
import ModalCloseButton from '~/common/components/Modals/ModalCloseButton';
import ModalContent from '~/common/components/Modals/ModalContent';
import ModalFooter from '~/common/components/Modals/ModalFooter';
import ModalHeader from '~/common/components/Modals/ModalHeader';
import ModalOverlay from '~/common/components/Modals/ModalOverlay';

type ModalProps = {
  fields?: any[];
  label?: string;
  title?: string;
  variant?: 'filled' | 'outlined';
  disabled?: boolean;
  actions?: any[];
};

export default function Modal({
  fields = [],
  label,
  title,
  variant,
  disabled = false,
}: Readonly<ModalProps>) {
  const [isOpen, setIsOpen] = useState(false);
  const { renderForm } = useFormApi();

  return (
    <>
      <Button
        onClick={() => {
          setIsOpen(true);
        }}
        disabled={disabled}
        variant={variant}
      >
        {label}
      </Button>
      <ChakraModal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <ModalOverlay />
        <ModalContent marginTop={350}>
          <ModalCloseButton />
          {title && <ModalHeader>{title}</ModalHeader>}
          <ModalBody mt="24px">
            {!!fields.length && renderForm([fields as any])}
          </ModalBody>
          <ModalFooter display="flex" justifyContent="center" pb="2rem">
            <Flex justifyContent="space-between" gridGap="12px">
              <Button
                onClick={() => {
                  setIsOpen(false);
                }}
              >
                Close
              </Button>
              <Button
                onClick={() => {
                  alert('How does this look?');
                  setIsOpen(false);
                }}
              >
                OK
              </Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </ChakraModal>
    </>
  );
}
